import { Segment, Grid, Icon, Divider, Header, Loader } from 'semantic-ui-react';

function DPPCompanyVerify({ dppCompanyVerifyData, loading }) {
    return (
        <Segment
            raised
            style={{
                maxWidth: "500px",
                margin: "20px auto",
                padding: "20px",
                borderRadius: "12px",
                backgroundColor: "#fff",
                boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
            }}
        >
            {loading ? (
                <Loader active inline="centered" size="large" />
            ) : (
                <>
                    {/* Document Preview */}
                    <Grid textAlign="center" stackable>
                        <Grid.Row>
                            <Header
                                as="h2"
                                style={{
                                    marginTop: '10px',
                                    color: '#2c3e50',
                                    fontWeight: '700',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    fontSize: "24px"
                                }}
                            >
                                <Icon name="check circle" color="green" size="large" />
                                <span style={{ marginTop: '8px' }}>Verified Authorization Letter</span>
                            </Header>

                            <p style={{ 
                                fontSize: '14px', 
                                color: '#555', 
                                marginTop: '12px', 
                                lineHeight: '1.6', 
                                padding: "0 10px" // Padding for better reading on mobile
                            }}>
                                This Authorization Letter is officially issued to the following <strong style={{ color: '#C8102E' }}>Hikvision Authorized Partner</strong>.
                            </p>

                        </Grid.Row>
                    </Grid>

                    <Divider style={{ borderTop: "2px solid #C8102E", margin: "20px 0" }} />

                    {/* Company Name Display without box */}
                    <div style={{
                        textAlign: "center",
                        fontSize: "22px",
                        fontWeight: "bold",
                        color: "#C8102E",
                        marginTop: "10px",
                        wordWrap: "break-word"
                    }}>
                        {dppCompanyVerifyData?.companyName || "N/A"}
                    </div>
                </>
            )}
        </Segment>
    );
}

export default DPPCompanyVerify;
